import React from "react";
import { InlineShareButtons } from "sharethis-reactjs";
import classes from "./ShareButtons.module.css";

const ShareButtons = () => {
  return (
    <div className={classes.shareContainer}>
      <div>Share:</div>
      <InlineShareButtons
        config={{
          alignment: "left", // alignment of buttons (left, center, right)
          color: "social", // color of buttons (social, white)
          enabled: true, // enable/disable the buttons
          font_size: 14, // font size for the share count
          labels: "null", // button labels (cta, counts, null)
          language: "en", // language for the buttons
          networks: [
            "facebook",
            "whatsapp",
            "twitter",
            "linkedin",
            "copy",
            "instagram",
          ],
          padding: 10, // padding within buttons
          radius: 8, // corner radius of buttons
          size: 35, // size of buttons
          show_total: false, // show/hide the total share count
        }}
      />
    </div>
  );
};

export default ShareButtons;
